import { render, staticRenderFns } from "./UpdateAForm.vue?vue&type=template&id=d146fede&"
import script from "./UpdateAForm.vue?vue&type=script&lang=js&"
export * from "./UpdateAForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports